var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0439 4.86332C15.9927 3.68408 15.8494 2.9164 15.4477 2.30911C15.2166 1.95973 14.9296 1.65586 14.5995 1.41123C13.7075 0.75 12.449 0.75 9.93221 0.75H6.86211C4.34525 0.75 3.08682 0.75 2.19478 1.41123C1.86475 1.65586 1.5777 1.95973 1.3466 2.30911C0.944973 2.91633 0.801591 3.68391 0.750409 4.86292C0.741653 5.06453 0.915318 5.21875 1.1056 5.21875C2.16531 5.21875 3.02438 6.12818 3.02438 7.25C3.02438 8.37182 2.16531 9.28121 1.1056 9.28121C0.915318 9.28121 0.741653 9.43545 0.750409 9.63711C0.801591 10.8161 0.944973 11.5837 1.3466 12.1909C1.5777 12.5402 1.86475 12.8441 2.19478 13.0888C3.08682 13.75 4.34525 13.75 6.86211 13.75H9.93221C12.449 13.75 13.7075 13.75 14.5995 13.0888C14.9296 12.8441 15.2166 12.5402 15.4477 12.1909C15.8494 11.5836 15.9927 10.8159 16.0439 9.63672V4.86332Z",
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16153 7.25H12.2204",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10269 10.3086H12.2203",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket_icon.83f79126fdcb8524baa808ae27ebba15.svg";
export { ForwardRef as ReactComponent };